import { useCallback } from "react";

import AnswersBuilderBase from "features/Library/Common/QuestionsForm/Answers/AnswersBuilders/AnswersBuilderBase";

import {
  type IAnswerBase,
  type IQuestion,
  type ValidationContext,
  type ValidationValueBase,
} from "features/Library/Common/models";
import { type AnswersBuilderPropsBase } from "features/Library/Common/props";
import { AnswersMap } from "features/Library/Assessments/Details/AssessmentContentForm/AssessmentProviders/AnswersMap";
import { getAnswerDefaultData } from "features/Library/Assessments/Details/AssessmentContentForm/AssessmentProviders/defaultAnswerProvider";
import { AssessmentAnswerType } from "features/Library/Assessments/types/state";
import { MAX_ANSWERS_LENGTH } from "features/Library/Common/constants";
import { AddButton } from "components/buttons/iconButtons/AddButton/AddButton";

export const AssessmentAnswersBuilder = (props: AnswersBuilderPropsBase<IQuestion<any>>) => {
  const { onBlur, onChanged, disabled, question, propertyNamePrefix } = props;

  const renderAnswer = useCallback(
    (
      answer: IAnswerBase,
      index: number,
      validatedFieldProps: ValidationContext<ValidationValueBase<IQuestion<any>>>,
    ) => {
      const { Component } = AnswersMap[answer.answerType as AssessmentAnswerType];
      let answerCopy = answer;
      if (answer.answerType === AssessmentAnswerType.SingleText) {
        answerCopy = {
          ...answer,
          answer: {
            ...answer.answer,
            isCorrect: question.question.correctAnswer === index,
          },
        };
      }
      return (
        <Component
          answer={answerCopy}
          index={index}
          validatedFieldProps={validatedFieldProps}
          disabled={disabled}
          onBlur={onBlur}
          onChanged={onChanged}
          propertyNamePrefix={propertyNamePrefix}
        />
      );
    },
    [disabled, onBlur, onChanged, question.question.correctAnswer, propertyNamePrefix],
  );

  const renderAddButton = (onClick: () => void) => {
    return !disabled && question.answers.length < MAX_ANSWERS_LENGTH ? (
      <AddButton onClick={onClick} label={"Add answer"} />
    ) : null;
  };

  return (
    <AnswersBuilderBase
      renderAnswer={renderAnswer}
      renderAddAnswerButton={renderAddButton}
      defaultDataProvider={getAnswerDefaultData}
      {...props}
    />
  );
};
